<template>
  <div>
    <v-card>
      <v-toolbar dense color="grey lighten-3" flat>
        <v-toolbar-title>{{labels.title}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn text icon @click="$emit('close')">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-container fluid grid-list-sm>
          <v-layout row wrap>
            <v-flex xs12 sm12 md12 lg12>
              <v-radio-group :label="labels.endorseType" v-model="endorseForm.endorseType" v-validate="'required'" class="ml-3 pa-0"
                :error-messages="errors.collect('endorseType')" data-vv-name="endorseType" :data-vv-as="labels.endorseType">
                <v-radio :label="labels.cancellation" value="C"></v-radio>
                <v-radio :label="labels.endorsement" value="E"></v-radio>
              </v-radio-group>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn depressed @click="$emit('close')"><span class="btn-normal-error">{{labels.cancel}}</span></v-btn>
        <v-btn depressed @click="doProceed"><span class="btn-normal-primary">{{labels.proceed}}</span></v-btn>
      </v-card-actions>
    </v-card>

    <v-dialog v-model="loading" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text class="pa-3">
          Processing...
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showErrorDialog" width="800px" >
      <v-card>
      <v-toolbar dense color="grey lighten-3" flat>
        <v-icon>mdi-information</v-icon>
        <v-toolbar-title>System Information</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <div v-if="messages.length > 0" class="pb-3">
        <v-subheader>Oops something went wrong:</v-subheader>
        <ul class="showErrorMsgs">
          <li v-for="(error, index) in messages" :key="index">
          {{error.message}}
          </li>
        </ul>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red darken-1" text @click.native="showErrorDialog = false">Close</v-btn>
      </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { expandURI } from '@/utils/ajax'
import { POLICY_ENDORSEMENT_MODE, POLICY_CANCELLATION_MODE } from '@/store/types'

export default {
  data () {
    return {
      labels: {
        title: 'Select Endorsement Type',
        endorseType: 'Endorsement Type',
        cancellation: 'Cancellation',
        endorsement: 'Endorsement',
        cancel: 'Cancel',
        proceed: 'Proceed'
      },
      endorseForm: {
        endorseType: null
      },
      loading: false,
      showErrorDialog: false
    }
  },
  props: {
    policyData: Object
  },
  computed: {
    displayErrorDialog() {
      return this.messages
    }
  },
  watch: {
    'displayErrorDialog': {
      handler: function (messages) {
        if (messages && messages.length > 0) {
          this.showErrorDialog = true
        }
      },
      deep: true
    }
  },
  methods: {
    doProceed() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          this.doEndorsement()
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doEndorsement() {
      const apiUrl = this.$store.state.underwriting.policyGeneralSettings.menu.endorsePolicy
      if (apiUrl) {
        try {
          this.loading = true
          const expand = {
            polNo: this.policyData.polNo,
            renCnt: this.policyData.renCnt,
            endtCnt: this.policyData.endtCnt,
            tranType: this.endorseForm.endorseType
          }
          const result = await this.$http.post(expandURI(apiUrl, expand))
          if (result) {
            const item = {
              polNo: result.data.polNo,
              renCnt: result.data.renCnt,
              endtCnt: result.data.endtCnt
            }
            const data = {
              item: item
            }

            if (this.endorseForm.endorseType === 'E') {
              this.$store.commit(POLICY_ENDORSEMENT_MODE)
            } else if (this.endorseForm.endorseType === 'C') {
              this.$store.commit(POLICY_CANCELLATION_MODE)
            }
            this.$store.dispatch('reviewPolicy', data).then(() => {
              this.$router.push({ name: 'policyGeneral' })
              this.loading = false
            })
            this.$emit('close')
            this.loading = false
          } else {
            this.loading = false
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
          return false
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    }
  },
  beforeMount() {
    if (this.$store.state.underwriting.policyGeneralSettings.init !== 1) {
      this.$store.dispatch('policyGeneralInit')
    }
  },
  mixins: [
    MessageMixin
  ]
}
</script>

<style>

</style>
